// extracted by mini-css-extract-plugin
export default {"infoField":"k0mDdGMKGPE5d3uHxbkZ","separator":"mhOMDIm1V7IenL5Kz3Ow","value":"qmGl9L4Mu8rwfAElwixw","label":"obqWO6q4aT8cq1pDP9f8"};